/**
 * @generated SignedSource<<4798b74d51b7c1992077de2b481eac37>>
 * @relayHash c95a5f84d5e59d796094fd4369b29459
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1b28e85e80da55e089dff774689ea5c0f515bfc059a2b06130bf7d192829bbe6

import type { ConcreteRequest } from 'relay-runtime';
export type getConsumptionEventDataQuery$variables = {
  contentId: string;
  spaceKey: string;
};
export type getConsumptionEventDataQuery$data = {
  readonly singleContent: {
    readonly id: string | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly type: string | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly status: string | null;
    readonly type: string | null;
  } | null;
};
export type getConsumptionEventDataQuery = {
  response: getConsumptionEventDataQuery$data;
  variables: getConsumptionEventDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "status"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "name": "subType"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getConsumptionEventDataQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getConsumptionEventDataQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "c95a5f84d5e59d796094fd4369b29459",
    "id": "1b28e85e80da55e089dff774689ea5c0f515bfc059a2b06130bf7d192829bbe6",
    "metadata": {},
    "name": "getConsumptionEventDataQuery",
    "operationKind": "query",
    "text": "query getConsumptionEventDataQuery($spaceKey:String!,$contentId:ID!){space(key:$spaceKey){id,type,status},singleContent(id:$contentId){id,status,type,subType}}"
  }
};
})();

(node as any).hash = "a468aeb5b2dd43bd9bd81e0a81d18bda";

export default node;
